import React from "react";

import { Link } from "react-router-dom";

function Fusion() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>AI&BIG DATA</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">빅데이터 융합 서비스</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="feature-style-1">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 company">
              <div className="company-tab">
                <ul className="nav nav-pills nav-justified">
                  <li>
                    <Link data-toggle="pill" to="/ai">
                      AI 관제 서비스{" "}
                    </Link>
                  </li>
                  <li>
                    <Link data-toggle="pill" to="/bigdata">
                      빅데이터 플랫폼{" "}
                    </Link>
                  </li>
                  <li className="active">
                    <Link data-toggle="pill" to="/fusion">
                      빅데이터 융합 서비스{"  "}
                    </Link>
                  </li>
                  {/* <li>
                    <Link data-toggle="pill" to="/tmap">
                      T-map API{"  "}
                    </Link>
                  </li> */}
                </ul>
                <div className="tab-content">

                <div className='tab_content_area'>
                                <div className="tab_title">
                                    빅데이터 융합 서비스
                                </div>
                                <div className='tab_paragraph'>
                                    <p>개요</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- 국내 최대 수준 Big Data와 조사 통계 Small Data를 매칭하여 Smart Data로 활용</li>
                                            <li>- 각 데이터가 지닌 한계를 최소화 하고 장점은 극대화 하는 새로운 접근법</li>
                                        </ul>
                                        <div className='servicePostBox4'>
                                            <div  className='smart_data1'>
                                                SMART DATA
                                            </div>
                                                <div className='servicePostBox7'>
                                                    <div className='smart_data2'>Fact 기반<p className='smart_data3'>Big Data</p> 개인의 태도/의도 확인불가</div>
                                                    <div className='smart_data4'>+</div>
                                                    <div className='smart_data2'>Opinion 기반 <p className='smart_data3'>Small Data</p>신뢰도의 한계 존재</div>
                                                </div>
                                        </div>
                                </div><br/>
                                <div className='tab_paragraph'>
                                    <p>특장점</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- Big Data 기반에 리서치 데이터 융합 분석 후 그 결과를 광고/판촉/추천 등 수요 기업 마케팅에 적용</li>
                                            <li>- SKT 통신 Big Data, KCB 금융 Big Data, 컨슈머인사이트 Small Data 등 전문성 있는 데이터 보유</li>
                                            <li>- Big Data는 융합을 통해 Insight 있는 데이터를 확보하여 고객 활성화, 충성화, 보상 강화에 활용</li>
                                            <li>- Small Data는 Fact 추가로 확신성 있는 데이터를 확보하여 마케팅 컨설팅, 리서치 상품 개발 활용</li>
                                            <li>- SKT의 위치정보와 행동의 이유, 금융 정보를 연결해 유동/유입 데이터에 풍부한 의미의 해석 부여 가능</li>
                                        </ul>
                                        <div className='tab_table2'>
                                            <table style={{border:'1px solid black', marginRight:'10px'}}>
                                                <thead>
                                                    <tr>
                                                        <th scope='col'><center>데이터명</center></th>
                                                        <th scope='col'><center>항목예시</center></th>
                                                        <th scope='col'><center>설명</center></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th scope='row' rowSpan='3' className='data2'><center>SKT 빅데이터<br/>(위치 기반,<br/>Life Style)</center></th>
                                                        <td>스포츠</td>
                                                        <td>스포츠 관람 시설 별</td>
                                                    </tr>
                                                    <tr>
                                                        <td>관광/레저</td>
                                                        <td>놀이공원, 레저 시설 별</td>
                                                    </tr>
                                                    <tr>
                                                        <td>모바일</td>
                                                        <td>사용기기, os 등</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope='row' rowSpan='3' className='data2'><center>KCB 빅데이터<br/>(고객 기반,<br/>금융, 소득, 소비)</center></th>
                                                        <td>성/연령</td>
                                                        <td>성별 및 생년월일</td>
                                                    </tr>
                                                    <tr>
                                                        <td>자산</td>
                                                        <td>주택, 부동산 등</td>
                                                    </tr>
                                                    <tr>
                                                        <td>소비</td>
                                                        <td>신용카드 등 소비 규모</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table style={{border:'1px solid black'}}>
                                                <thead>
                                                    <tr>
                                                        <th scope='col'><center>데이터명</center></th>
                                                        <th scope='col'><center>항목예시</center></th>
                                                        <th scope='col'><center>설명</center></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th scope='row' rowSpan='3' className='data2'><center>컨슈머인사이트<br/>여행/관광<br/>데이터<br/>(국내여행)</center></th>
                                                        <td>여행 지역</td>
                                                        <td>17개 광역, 229 시군구</td>
                                                    </tr>
                                                    <tr>
                                                        <td>여행 기간</td>
                                                        <td>여행 중 기간</td>
                                                    </tr>
                                                    <tr>
                                                        <td>경비</td>
                                                        <td>식사/숙박/교통 등</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope='row' rowSpan='3' className='data2'><center>컨슈머인사이트<br/>여행/관광<br/>데이터<br/>(해외여행)</center></th>
                                                        <td>여행 국가</td>
                                                        <td>약 50여개 국가</td>
                                                    </tr>
                                                    <tr>
                                                        <td>주 활동</td>
                                                        <td>총 10개 보기 구성</td>
                                                    </tr>
                                                    <tr>
                                                        <td>종합 만족도</td>
                                                        <td>5점 척도</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                </div>
                                <div className='tab_paragraph'>
                                    <p>데이터 가공 예시</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- 데이터 특성에 따른 전국 지자체 단위 분석 가능</li>
                                            <li>- Web 기반 통계 패키지로 누구나 쉽게 분석 가능하며 시각적 결과 보고서 제시</li>
                                        </ul>
                                        <div className='servicePostBox3'>
                                            <div>
                                                <img src='./images/service/Ai3/image20.png' alt=''/>
                                                <p>지역 관광 기초 환경 보고서 - 17개 시도, 229시군구 단위</p>
                                            </div>
                                            <div>
                                                <img src='./images/service/Ai3/image21.png' alt=''/>
                                                <p>Web 기반 통계 패키지</p>
                                            </div>
                                        </div>
                                </div>
                            </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Fusion;
